import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import isExternalUrl from 'commons/isExternalUrl';
import PropTypes from 'prop-types';
const SubLink = t0 => {
  const $ = _c(6);
  const {
    name,
    url
  } = t0;
  let t1;
  if ($[0] !== name || $[1] !== url) {
    t1 = isExternalUrl(url) ? <a href={url} className="font-normal text-base leading-[25px] text-[#888] border-0 no-underline hover:text-[#484848] hover:transition-[opacity_.3s,transform_.3s] hover:![border-bottom:1px_solid_#484848]">{name}</a> : <Link to={url} className="font-normal text-base leading-[25px] text-[#888] border-0 no-underline hover:text-[#484848] hover:transition-[opacity_.3s,transform_.3s] hover:![border-bottom:1px_solid_#484848]">{name}</Link>;
    $[0] = name;
    $[1] = url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1 || $[4] !== url) {
    t2 = <li key={url}>{t1}</li>;
    $[3] = t1;
    $[4] = url;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
SubLink.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string
};
export default SubLink;